import styled from 'styled-components';

export const StyledSurveyFooter = styled.footer`
    width: 100%;
    height: 40px;
    display: flex;
    gap: 1rem;
    justify-content: center;
    align-items: center;
    margin-top: auto;

    a {
        font-size: 0.8rem;
        color: #000;
        text-decoration: none;
    }
`;
